import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import COLORS from '../../../../../../@commons/constants/colors.constants';

@Component({
    selector: 'vw-calendar-period-line',
    imports: [CommonModule],
    templateUrl: './calendar-period-line.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './calendar-period-line.component.scss'
})
export class CalendarPeriodLineComponent {
  @Input() periods: { startMonth: number, endMonth: number }[];
  @Input() type: 'SEEDLING' | 'PLANTING' | 'HARVEST' = 'SEEDLING';
  COLORS = COLORS;

  isInPeriod(month: number): boolean {
    return this.periods.some(period => {
      if (period.startMonth > period.endMonth) {
        return month >= period.startMonth || month <= period.endMonth;
      }
      return month >= period.startMonth && month <= period.endMonth;
    });
  }

  isFirstPeriod(month: number): boolean {
    return this.periods.some(period => period.startMonth === month);
  }

  isLastPeriod(month: number): boolean {
    return this.periods.some(period => period.endMonth === month);
  }
}
